import { DeviceSample } from '../models/deviceSample'

export interface MeasurementsStateType {
  deviceSamples: DeviceSample[]
  deviceSample: DeviceSample | null
  loading: boolean
  error: string | null
}

const MeasurementsState: () => MeasurementsStateType = () => ({
  deviceSamples: [],
  deviceSample: null,
  loading: false,
  error: null,
})

export default MeasurementsState